export const customersContants = {
  GET_ALL_CUSTOMERS: "GET_ALL_CUSTOMERS",
};
